<template>
  <div class="col-sm-12">
    <div class="report-title">
      {{ $t('road_reports.total_observations') }}: {{ reportData.total_pcs }}
    </div>
    <vue3-datatable
          v-if="tableItems.length > 0"
          ref="datatable"
          :rows="tableItems"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="false"
          :has-checkbox="false"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
      >
    </vue3-datatable>
  </div>
</template>

<script>
import Vue3Datatable from '@bhplugin/vue3-datatable'
export default {
    name: "RoadReportSummary",
    components: {Vue3Datatable},
    props: {
        reportData: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            tableItems: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'obs_type', title: this.$t('road_reports.type')},
                {field: 'count', title: this.$t('road_reports.count')},
                {field: 'len', title: this.$t('road_reports.length')}
            ]
        }
    },
    mounted: function () {
        const temp = []
        for (const [typeName, type] of Object.entries(this.reportData.obs_types)) {
            temp.push({
                obs_type: typeName,
                count: type.pcs,
                len: type['length'] >= 0 ? Math.round(type['length']) : ''
            })
        }
        this.$nextTick(() => this.tableItems = temp)

    }
}
</script>

<style scoped>

</style>
